import { render, staticRenderFns } from "./change-stakeholders-request-column.vue?vue&type=template&id=88313ea6"
import script from "./change-stakeholders-request-column.vue?vue&type=script&lang=js"
export * from "./change-stakeholders-request-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports